import React, { useEffect, useState } from "react";
import "./styles.scss";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from "uuid";
import { Tabs } from "antd";
import { GetIconByName } from "../../config/icon";

const { TabPane } = Tabs;

const Index = (data, onEdit, onChange, items, object) => {
  const [tabList, setTabList] = useState([]);
  let elementContent = null;

  elementContent = (
    <>
      <Tabs defaultActiveKey="1" items={data.items} onChange={data.onChange} />
    </>
  );
  return <div className={"tab-component-wrapper"}>{elementContent}</div>;
};

Index.propTypes = {
  tabName: PropTypes.string,
};

export default Index;
